export const CONTRACT_ADDRESS = '0xb0A747d220F3f793E1E16Bf068f27C3aa3eb7a44';
export const BULLDROIDS_JSON_URL = 'https://bulldroapp-storage-d1sj4cr45c2t8p235618-production.s3.amazonaws.com/2b7kIJep6Mi4HV4aZDJ';
